export const CREATE_PART = 'CREATE_PART';
export const LOAD_PARTS = 'LOAD_PARTS';
